"use strict";

(function () {
  new Vue({
    el:'#department-app',
    data: function () {
      return {
        department: {
          Category1: {
            activeIcon: [
              'assets/img/common/ranking/department/icon01-1_on.png',
              'assets/img/common/ranking/department/icon01-2_on.png',
              'assets/img/common/ranking/department/icon01-3_on.png',
              'assets/img/common/ranking/department/icon01-4_on.png',
              'assets/img/common/ranking/department/icon01-5_on.png'
            ],
          },
          Category2: {
            activeIcon: [
              'assets/img/common/ranking/department/icon02-1_on.png',
              'assets/img/common/ranking/department/icon02-2_on.png',
              'assets/img/common/ranking/department/icon02-3_on.png'
            ],
          },
          Category3: {
            activeIcon: [
              'assets/img/common/ranking/department/icon03-1_on.png',
              'assets/img/common/ranking/department/icon03-2_on.png',
              'assets/img/common/ranking/department/icon03-3_on.png',
              'assets/img/common/ranking/department/icon03-4_on.png',
              'assets/img/common/ranking/department/icon03-5_on.png'
            ],
          },
          Category4: {
            activeIcon: [
              'assets/img/common/ranking/department/icon04-1_on.png',
              'assets/img/common/ranking/department/icon04-2_on.png',
              'assets/img/common/ranking/department/icon04-3_on.png',
              'assets/img/common/ranking/department/icon04-4_on.png'
            ],
          },
        },
        activeCategory1: '1-1',
        activeCategory2: '2-1',
        activeCategory3: '3-1',
        activeCategory4: '4-1',
      };
    },
    methods: {
      changeDepartment: function (e) {
        const departmentId = e.target.getAttribute('data-department-id');
        const category = departmentId.slice(0, 1);

        switch (category) {
          case '1':
            this.activeCategory1 = e.target.getAttribute('data-department-id');
            break;
          case '2':
            this.activeCategory2 = e.target.getAttribute('data-department-id');
            break;
          case '3':
            this.activeCategory3 = e.target.getAttribute('data-department-id');
            break;
          case '4':
            this.activeCategory4 = e.target.getAttribute('data-department-id');
            break;
        }

      }
    }
  })

  $.each($('.icon'), function () {
    $(this).on('click', function () {
      const departmentId = $(this).children('img').attr('data-department-id');
      const category = departmentId.slice(0, 1);
      switch (category) {
        case '1':
          $('.ttl01').removeClass('active');
          break;
        case '2':
          $('.ttl02').removeClass('active');
          break;
        case '3':
          $('.ttl03').removeClass('active');
          break;
        case '4':
          $('.ttl04').removeClass('active');
          break;
      }
      $(this).siblings('.ttl').addClass('active');
    });
  });

})();